"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EIP712MessageValidator = exports.EIP712DomainTypeValidator = exports.EIP712PropertyFieldValidator = void 0;
const joi_1 = __importDefault(require("joi"));
// https://eips.ethereum.org/EIPS/eip-712
exports.EIP712PropertyFieldValidator = joi_1.default.object({
    name: joi_1.default.string().min(1).required(),
    // TODO: Check valid types (string, bool, address, uint256...)
    type: joi_1.default.string().min(1).required(),
});
exports.EIP712DomainTypeValidator = joi_1.default.array()
    .items(joi_1.default.object({
    name: joi_1.default.string().valid("name").required(),
    type: joi_1.default.string().valid("string").required(),
}), joi_1.default.object({
    name: joi_1.default.string().valid("version").required(),
    type: joi_1.default.string().valid("string").required(),
}), joi_1.default.object({
    name: joi_1.default.string().valid("chainId").required(),
    type: joi_1.default.string().valid("uint256").required(),
}), joi_1.default.object({
    name: joi_1.default.string().valid("verifyingContract").required(),
    // From https://eips.ethereum.org/EIPS/eip-712, (string) may be non-standard?
    // But, ethermint set this type as string.
    type: joi_1.default.string().valid("address", "string").required(),
}), joi_1.default.object({
    name: joi_1.default.string().valid("salt").required(),
    // From https://eips.ethereum.org/EIPS/eip-712, (string) may be non-standard?
    // But, ethermint set this type as string.
    type: joi_1.default.string().valid("bytes32", "string").required(),
}))
    .unique()
    .min(1)
    .custom((value) => {
    // Sort by name
    const domainFieldNames = [
        "name",
        "version",
        "chainId",
        "verifyingContract",
        "salt",
    ];
    return value.sort((a, b) => {
        return (domainFieldNames.indexOf(a.name) - domainFieldNames.indexOf(b.name));
    });
});
exports.EIP712MessageValidator = joi_1.default.object({
    types: joi_1.default.object({
        EIP712Domain: exports.EIP712DomainTypeValidator.required(),
    })
        .unknown(true)
        .required(),
    primaryType: joi_1.default.string().min(1).required(),
    domain: joi_1.default.object().required(),
    message: joi_1.default.object().required(),
});
//# sourceMappingURL=eip712.js.map